exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".igx-snackbar{display:flex;position:relative;flex-flow:row nowrap;align-items:center;justify-content:space-between;min-height:3em;padding:.4375em 1.5em;background:rgba(0,0,0,.74);color:#fff;backface-visibility:hidden}.igx-snackbar__message{font-size:.875em}.igx-snackbar__button{background:transparent;color:#e41c77;border:0;line-height:1em;margin-left:1.5em;text-transform:uppercase;user-select:none;font-weight:600;-webkit-tap-highlight-color:transparent;outline:none;transition:color .2s ease}.igx-snackbar__button:hover{color:#e41c77}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true}!./node_modules/sass-loader/lib/loader.js!./src/snackbar/snackbar.component.scss
// module id = 125
// module chunks = 0 1